export default __webpack_public_path__ + "static/media/3.ca3532b4.webp";